/**
 * custom-phaser-stoq-notify.js
 *
 * Stoq (Restock Rocket) on Phaser is configured as a float-right side tab.
 * CCC uses position "specific" after `.product-form-buttons`, which puts
 * "Notify me when available" under the Sold out button.
 *
 * Until Stoq admin on Phaser matches CCC (position: specific,
 * selector: .product-form-buttons), relocate the float widget into that slot
 * and restyle it as a full-width PDP button.
 */
(() => {
  const FLOAT_CONTAINER_SEL =
    '.restock-rocket-button-container-float-right, .restock-rocket-button-container-float-left';
  const ANCHOR_SEL = '.product-details .product-form-buttons';
  const INLINE_CLASS = 'phaser-stoq-notify--inline';

  /**
   * @returns {HTMLElement | null}
   */
  const getAnchor = () => document.querySelector(ANCHOR_SEL);

  /**
   * @param {HTMLElement} container
   * @param {HTMLElement} anchor
   */
  const placeContainer = (container, anchor) => {
    if (container.classList.contains(INLINE_CLASS) && container.previousElementSibling === anchor) {
      return;
    }

    container.classList.add(INLINE_CLASS);
    container.setAttribute('data-phaser-stoq-inline', 'true');

    const button = container.querySelector(
      '.restock-rocket-button, .restock-rocket-button-float, .restock-rocket-button-product'
    );

    if (button) {
      button.classList.add('phaser-stoq-notify__button');
    }

    anchor.insertAdjacentElement('afterend', container);
  };

  const placeAll = () => {
    const anchor = getAnchor();

    if (!anchor) {
      return;
    }

    const floats = document.querySelectorAll(FLOAT_CONTAINER_SEL);

    for (const container of floats) {
      if (!(container instanceof HTMLElement)) {
        continue;
      }

      placeContainer(container, anchor);
    }
  };

  /** @type {number | null} */
  let scheduled = null;

  const schedulePlace = () => {
    if (scheduled !== null) {
      return;
    }

    scheduled = window.setTimeout(() => {
      scheduled = null;
      placeAll();
    }, 50);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePlace, { once: true });
  } else {
    schedulePlace();
  }

  // Stoq injects late; variant morphs can recreate the float tab.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) {
          continue;
        }

        if (
          node.matches?.(FLOAT_CONTAINER_SEL) ||
          node.querySelector?.(FLOAT_CONTAINER_SEL)
        ) {
          schedulePlace();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('variant:selected', schedulePlace);
  document.addEventListener('product:variant-change', schedulePlace);

  // Stoq can take a few hundred ms after first paint.
  window.setTimeout(schedulePlace, 300);
  window.setTimeout(schedulePlace, 1200);
})();
